
import { Component, OnInit, Output,EventEmitter, Input } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { GlobalVariables } from 'src/app/services/local/globalVariables.service';
import { FormsModule } from '@angular/forms';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LucideAngularModule } from 'lucide-angular';

@Component({
    selector: 'app-search-budget',
    templateUrl: './search-budget.component.html',
    styleUrls: ['./search-budget.component.css'],
    imports: [FormsModule, NgIf, MatProgressSpinner, NgFor, LucideAngularModule]
})
export class SearchBudgetComponent implements OnInit {

  @Output() Budget = new EventEmitter();
  @Output() closeBudgetSearch = new EventEmitter();
  @Input()  criteria: any;
  @Input() enterprise: any;

  constructor(private api: ApiService,private globalVariables: GlobalVariables) { }

  serial: string;
  budgetNumber: string
  error: boolean;
  budgets: Array<any>=[]
  loading: boolean
  searchText: any =""
  token: any;
  selectedDiv: number | null = null;
  msg: string
  imagepath: string=''
  

  ngOnInit(): void {

    this.imagepath=this.globalVariables.getUrlImage()

    if (!this.criteria.field)
    {
      console.log('entra cuando no es undefined')
    }

    if (this.criteria.field!='' || !this.criteria.field)
    {
     const indx =this.criteria.field.indexOf('/')
     this.serial= this.criteria.field.substring(0,indx)
     this.budgetNumber= this.criteria.field.substring(indx+1)
    }

  }

  searchBudget(event?){

    let formattedBudget: any
    let formattedSerial:any
    let formattedBudgetWithSerial: any
    let result: string
    let workplace: string
    let year: string

    this.budgets=[];
    this.error=false;
    formattedBudget=''
    formattedSerial=''
    formattedBudgetWithSerial=''

    result= removeSpacesAndSpecialChars(this.serial)

    workplace= result.substring(0,result.length-2)
    year= result.substring(workplace.length, result.length)
    formattedSerial=workplace+'_'+year

  //  console.log(workplace,'workplace')
   // console.log(year,'year')
 //   console.log(formattedSerial,'formattedSerial')

    formattedBudget=removeSpacesAndSpecialChars(this.budgetNumber);
  
    formattedBudgetWithSerial= formattedSerial + '/' + formattedBudget

    this.searchBudgets(formattedBudgetWithSerial,this.enterprise)
  }

  selectBudget(event,item){
  //  console.log(item)
    this.closeEvent(item)
  }

  clearBudgets(event){
    event.stopPropagation();
    event.preventDefault();

    this.budgets=[]
    //this.criteria={field:'name',value:'' }
    this.loading=false
    this.msg=''
    this.serial=''
    this.budgetNumber=''

  }

  highlightDiv(index:number):void{
    this.selectedDiv = index;
  }

  onKey(value){

    this.searchBudget()

  }


  closeEvent(item?:any){

    if (item.budget)
      this.closeBudgetSearch.emit({budget:item})
    else 
    { 
      const budget={budget: {budget:this.criteria.field, id_budget:this.criteria.id}}
      this.closeBudgetSearch.emit(budget)
    }
      
  }

  searchBudgets(document:any, enterprise:any, id?:boolean){
    let data_budget: any
    let context_budget: any
    this.loading=true

    if (enterprise.length<2)
      enterprise= '0' + enterprise.toString()

    context_budget = `[{"ENTERPRISE_CODE":"${enterprise}"}]`

    if(!id){
        data_budget=`[{\"SEARCH_TEXT\":"${document}" ,\"ROWID_DIRECTO\":\"\"}]`
    }
    else
    {
        data_budget=`[{\"SEARCH_TEXT\":\"\" ,\"ROWID_DIRECTO\":"${document}"}]`
    
    }

    this.api.getTokenGTS().subscribe(res=>{
      this.token=res.value
      this.api.budgets(this.token,data_budget,context_budget).subscribe(res=>{
        if(res.value.Rows.length>0){
          res.value.Rows.forEach(row=>{
            if (row.NUM_PRESUPUESTO)
              {
                this.budgets.push({budget: row.NUM_PRESUPUESTO, id_budget:row._ROWID})

              }
             
            else{
               this.msg='No hay presupuestos con el criterio de búsqueda actual'
               this.error=false
            }
            this.loading=false
             
          })
        }
        else
        { this.error=false
          this.loading=false
          this.msg='No hay presupuestos con el criterio de búsqueda actual'
        }
        
      })
    
    })
 
    
  }

}

function removeSpacesAndSpecialChars(field: string){
  const result= field.replace(/[^a-zA-Z0-9]/g, "");
 return result
}


